import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledDivComponent } from '../types';
import { ButtonLink } from './Button';
import { Icon } from './Icon';
import { PillCloud } from './Pill';

export interface ModalProps {
  plain?: boolean;
  gallery?: boolean;
  centered?: boolean;
  zoom?: boolean;
  forVideo?: boolean;
}

type ModalPropsThemed = ThemeProps<Theme> & ModalProps;

export const Modal: StyledDivComponent<ModalProps> = styled.div`
  position: relative;

  background-color: ${(props: ModalPropsThemed) =>
    props.plain
      ? props.theme.components.modal.plain.background
      : props.theme.colors.white};
  max-width: 580px;

  ${(props: ModalPropsThemed) =>
    props.plain &&
    css`
      max-width: ${props.theme.components.modal.plain.width};
    `}

    ${(props: ModalPropsThemed) =>
    (props.plain && props.forVideo) &&
    css`
      max-width: 90%;
    `}

  ${(props: ModalPropsThemed) =>
    props.gallery &&
    css`
      max-width: 880px;
    `}

  ${(props: ModalPropsThemed) =>
    props.zoom &&
    css`
      max-width: 1280px;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
    `}

  padding: ${(props: ModalPropsThemed) =>
    props.plain
      ? props.theme.components.modal.plain.padding
      : props.theme.components.modal.padding};

  ${(props: ModalPropsThemed) =>
    props.centered
      ? css`
          position: fixed;
          top: 50%;
          left: 50%;
          z-index: 1100;
          transform: translate(-50%, -50%);
        `
      : css`
          margin: 50px auto;
        `}

  ${ButtonLink} {
    margin-bottom: 20px;
  }

  ${PillCloud} {
    margin-bottom: 20px;
  }
`;

export const ModalClose: StyledDivComponent = styled.div`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  transition: ${({ theme }: ThemeProps<Theme>) => theme.defaults.transition};

  ${Icon} {
    margin: 0;
    width: 24px;
    height: 24px;
  }

  &:hover {
    ${Icon} {
      svg {
        fill: ${({ theme }: ThemeProps<Theme>) => theme.colors.primary};
      }
    }
  }
`;
